// @ts-nocheck
import {
  ADD_CONTRACTOR_STEP1_FAILURE,
  ADD_CONTRACTOR_STEP1_REQUEST,
  ADD_CONTRACTOR_STEP1_SUCCESS,
  ADD_CONTRACTOR_STEP1_UPDATE_FAILURE,
  ADD_CONTRACTOR_STEP1_UPDATE_REQUEST,
  ADD_CONTRACTOR_STEP1_UPDATE_SUCCESS,
  ADD_CONTRACTOR_STEP2_FAILURE,
  ADD_CONTRACTOR_STEP2_REQUEST,
  ADD_CONTRACTOR_STEP2_SUCCESS,
  ADD_CONTRACTOR_STEP3_FAILURE,
  ADD_CONTRACTOR_STEP3_REQUEST,
  ADD_CONTRACTOR_STEP3_SUCCESS,
  ADD_CONTRACTOR_STEP4_FAILURE,
  ADD_CONTRACTOR_STEP4_REQUEST,
  ADD_CONTRACTOR_STEP4_SUCCESS,
  ADD_CONTRACTOR_STEP5_FAILURE,
  ADD_CONTRACTOR_STEP5_REQUEST,
  ADD_CONTRACTOR_STEP5_SUCCESS,
  ADD_PREFERRED_POSITION_FAILURE,
  ADD_PREFERRED_POSITION_REQUEST,
  ADD_PREFERRED_POSITION_SUCCESS,
  APPROVE_CONTRACTOR_FAILURE,
  APPROVE_CONTRACTOR_REQUEST,
  APPROVE_CONTRACTOR_SUCCESS,
  BULK_EDIT_CONTRACTOR_FAILURE,
  BULK_EDIT_CONTRACTOR_REQUEST,
  BULK_EDIT_CONTRACTOR_SUCCESS,
  BULK_UPDATE_CONTRACTOR_AND_PO_STATUS_REQUEST,
  BULK_UPDATE_CONTRACTOR_AND_PO_STATUS_SUCCESS,
  CLEAR_ADD_CONTRACTOR,
  CREATE_CONTRACTOR_FAILURE,
  CREATE_CONTRACTOR_REQUEST,
  CREATE_CONTRACTOR_SUCCESS,
  DELETE_CONTRACTOR_FAILURE,
  DELETE_CONTRACTOR_REQUEST,
  DELETE_CONTRACTOR_SUCCESS,
  FETCH_CONTRACTORS_FAILURE,
  FETCH_CONTRACTORS_REQUEST,
  FETCH_CONTRACTORS_SUCCESS,
  GET_PO_HISTORY_FAILURE,
  GET_PO_HISTORY_REQUEST,
  GET_PO_HISTORY_SUCCESS,
  GUSTO_APPROVE_CONTRACTOR_FAILURE,
  GUSTO_APPROVE_CONTRACTOR_REQUEST,
  GUSTO_APPROVE_CONTRACTOR_SUCCESS,
  REMOVE_PREFERRED_POSITION_FAILURE,
  REMOVE_PREFERRED_POSITION_REQUEST,
  REMOVE_PREFERRED_POSITION_SUCCESS,
  RESET_CONTRACTOR_PASSWORD_FAILURE,
  RESET_CONTRACTOR_PASSWORD_REQUEST,
  RESET_CONTRACTOR_PASSWORD_SUCCESS,
  SETUP_EDIT_CONTRACTOR_FAILURE,
  SETUP_EDIT_CONTRACTOR_REQUEST,
  SETUP_EDIT_CONTRACTOR_SUCCESS,
  SET_CONTRACTOR_MULTIPLE_FIELDS,
  TOGGLE_ADP_STATUS_FAILURE,
  TOGGLE_ADP_STATUS_REQUEST,
  TOGGLE_ADP_STATUS_SUCCESS,
  TOGGLE_CONTRACTOR_STATUS_FAILURE,
  TOGGLE_CONTRACTOR_STATUS_REQUEST,
  TOGGLE_CONTRACTOR_STATUS_SUCCESS,
  TOGGLE_ONBOARDING_STATUS_FAILURE,
  TOGGLE_ONBOARDING_STATUS_REQUEST,
  TOGGLE_ONBOARDING_STATUS_SUCCESS,
  UPDATE_CONTRACTOR_CERTIFICATES_STEP5,
  UPDATE_CONTRACTOR_FAILURE,
  UPDATE_CONTRACTOR_REQUEST,
  UPDATE_CONTRACTOR_SUCCESS,
} from "../constants/contractor";

const addContractorInit = {
  contractorData: {
    // isEditing: false,
    isEditable: false,
    loading: false,
    loaded: false,
  },
  step1: {
    submitFormRequestLoading: false,
    data: null,
    form: null,
    previouslySubmittedForm: null,
  },
  step2: {
    submitFormRequestLoading: false,
    data: null,
    form: null,
    previouslySubmittedForm: null,
  },
  step3: {
    submitFormRequestLoading: false,
    data: null,
    form: null,
    previouslySubmittedForm: null,
  },
  step4: {
    submitFormRequestLoading: false,
    data: null,
    form: null,
    previouslySubmittedForm: null,
  },
  step5: {
    submitFormRequestLoading: false,
    data: null,
    form: null,
    previouslySubmittedForm: null,
  },
  reset: {
    count: null,
  },
};

const initialState = {
  contractors: [],
  searchString: "",
  airportSearchString: "",
  airportFilters: null,
  searchBy: null,
  // State / City / Role filter of the contractor search (2026-09-11)
  crewFilter: null,
  // last `meta` of getAllContractors (hiddenWithoutLocation, totalCount…)
  contractorsMeta: null,
  isLoading: false,
  statusLoader: false,
  totalPages: 0,
  currentPage: 1,
  rPerPage: 50,
  pLoading: false,
  aLoading: false,
  gLoading: false,
  adpLoading: false,
  addContractor: addContractorInit,
  poHistory: {
    isPOHistoryLoading: false,
    data: [],
  },
  bulkEditLoader: false,
  bulkEditWithPOLoader: false,
};

const contractorReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_CONTRACTOR_MULTIPLE_FIELDS:
      return {
        ...state,
        ...action?.payload,
      };

    // fetch contractors
    case FETCH_CONTRACTORS_REQUEST:
      return {
        ...state,
        searchString: action.payload?.search,
        airportFilters: action?.payload?.airportFilters,
        searchBy: action?.payload?.searchBy,
        crewFilter: action?.payload?.crewFilter ?? null,
        isLoading: true,
      };
    case FETCH_CONTRACTORS_SUCCESS:
      return {
        ...state,
        contractors: action.payload?.data,
        contractorsMeta: action?.payload?.meta ?? null,
        isLoading: false,
        totalPages: action?.payload?.meta?.totalPages,
        currentPage: action?.payload?.meta?.currentPage,
        rPerPage: action?.payload?.meta?.perPage,
      };
    case FETCH_CONTRACTORS_FAILURE:
      return {
        ...state,
        isLoading: false,
      };

    // toggle contractor status
    case TOGGLE_CONTRACTOR_STATUS_REQUEST:
      return {
        ...state,
        statusLoader: true,
      };
    case TOGGLE_CONTRACTOR_STATUS_SUCCESS:
      return {
        ...state,
        statusLoader: false,
        contractors: state.contractors.map((item) => {
          if (item._id === action.payload._id) {
            return { ...item, isActive: !item.isActive };
          } else {
            return item;
          }
        }),
      };
    case TOGGLE_CONTRACTOR_STATUS_FAILURE:
      return {
        ...state,
        statusLoader: false,
      };

    // delete contractor
    case DELETE_CONTRACTOR_REQUEST:
      return {
        ...state,
        isLoading: true,
      };
    case DELETE_CONTRACTOR_SUCCESS:
      return {
        ...state,
        isLoading: false,
        contractors: state.contractors.filter(
          (item) => item._id !== action.payload,
        ),
      };
    case DELETE_CONTRACTOR_FAILURE:
      return {
        ...state,
        isLoading: false,
      };

    // create contractor
    case CREATE_CONTRACTOR_REQUEST:
      return {
        ...state,
        isLoading: true,
      };
    case CREATE_CONTRACTOR_SUCCESS:
      return {
        ...state,
        isLoading: false,
      };
    case CREATE_CONTRACTOR_FAILURE:
      return {
        ...state,
        isLoading: false,
      };

    //case update contractor
    case UPDATE_CONTRACTOR_REQUEST:
      return {
        ...state,
        isLoading: true,
      };
    case UPDATE_CONTRACTOR_SUCCESS:
      return {
        ...state,
        isLoading: false,
      };
    case UPDATE_CONTRACTOR_FAILURE:
      return {
        ...state,
        isLoading: false,
      };

    // case add preferrd position
    case ADD_PREFERRED_POSITION_REQUEST:
      return {
        ...state,
        pLoading: true,
      };

    case ADD_PREFERRED_POSITION_SUCCESS:
      return {
        ...state,
        pLoading: false,
      };

    case ADD_PREFERRED_POSITION_FAILURE:
      return {
        ...state,
        pLoading: false,
      };

    // remove preferred position
    case REMOVE_PREFERRED_POSITION_REQUEST:
      return {
        ...state,
        pLoading: true,
      };

    case REMOVE_PREFERRED_POSITION_SUCCESS:
      return {
        ...state,
        pLoading: false,
      };

    case REMOVE_PREFERRED_POSITION_FAILURE:
      return {
        ...state,
        pLoading: false,
      };

    // approve contractor
    case APPROVE_CONTRACTOR_REQUEST:
      return {
        ...state,
        aLoading: true,
      };
    case APPROVE_CONTRACTOR_SUCCESS:
      return {
        ...state,
        contractors: state.contractors.map((con) => {
          if (con._id === action.payload?.id) {
            return {
              ...action?.payload?.data,
            };
          } else {
            return con;
          }
        }),
        aLoading: false,
      };
    case APPROVE_CONTRACTOR_FAILURE:
      return {
        ...state,
        aLoading: false,
      };

    // approve contractor
    case GUSTO_APPROVE_CONTRACTOR_REQUEST:
      return {
        ...state,
        gLoading: true,
      };
    case GUSTO_APPROVE_CONTRACTOR_SUCCESS:
      return {
        ...state,
        contractors: state.contractors.map((con) => {
          if (con._id === action.payload?.id) {
            return {
              ...action?.payload?.data,
            };
          } else {
            return con;
          }
        }),
        gLoading: false,
      };
    case GUSTO_APPROVE_CONTRACTOR_FAILURE:
      return {
        ...state,
        gLoading: false,
      };
    case ADD_CONTRACTOR_STEP1_REQUEST:
      return {
        ...state,
        addContractor: {
          ...state?.addContractor,
          step1: {
            ...state?.addContractor?.step1,
            submitFormRequestLoading: true,
          },
        },
      };

    case ADD_CONTRACTOR_STEP1_SUCCESS:
      return {
        ...state,
        addContractor: {
          ...state?.addContractor,
          step1: {
            ...state?.addContractor?.step1,
            data: action?.payload?.data,
            submitFormRequestLoading: false,
            form: action?.payload?.formData,
            previouslySubmittedForm: action.payload?.formData,
          },
          step2: {
            ...state?.addContractor?.step2,
            form: {
              ...state?.addContractor?.step2?.data,
              roleExperience:
                action?.payload?.data?.roleExperience ||
                state?.addContractor?.step2?.form?.roleExperience,
            },
          },
        },
      };

    case ADD_CONTRACTOR_STEP1_FAILURE:
      return {
        ...state,
        addContractor: {
          ...state?.addContractor,
          step1: {
            ...state?.addContractor?.step1,
            submitFormRequestLoading: false,
          },
        },
      };

    case ADD_CONTRACTOR_STEP1_UPDATE_REQUEST:
      return {
        ...state,
        addContractor: {
          ...state?.addContractor,
          step1: {
            ...state?.addContractor?.step1,
            submitFormRequestLoading: true,
          },
        },
      };

    case ADD_CONTRACTOR_STEP1_UPDATE_SUCCESS:
      return {
        ...state,
        addContractor: {
          ...state?.addContractor,
          step1: {
            ...state?.addContractor?.step1,
            data: action?.payload?.data,
            submitFormRequestLoading: false,
            form: action?.payload?.formData,
            previouslySubmittedForm: action.payload?.formData,
          },
        },
      };

    case ADD_CONTRACTOR_STEP1_UPDATE_FAILURE:
      return {
        ...state,
        addContractor: {
          ...state?.addContractor,
          step1: {
            ...state?.addContractor?.step1,
            submitFormRequestLoading: false,
          },
        },
      };

    case ADD_CONTRACTOR_STEP2_REQUEST:
      return {
        ...state,
        addContractor: {
          ...state?.addContractor,
          step2: {
            ...state?.addContractor?.step2,
            submitFormRequestLoading: true,
          },
        },
      };

    case ADD_CONTRACTOR_STEP2_SUCCESS:
      return {
        ...state,
        addContractor: {
          ...state?.addContractor,
          step2: {
            ...state?.addContractor?.step2,
            data: action?.payload?.data,
            submitFormRequestLoading: false,
            form: action?.payload?.formData,
            previouslySubmittedForm: action.payload?.formData,
          },
        },
      };

    case ADD_CONTRACTOR_STEP2_FAILURE:
      return {
        ...state,
        addContractor: {
          ...state?.addContractor,
          step2: {
            ...state?.addContractor?.step2,
            submitFormRequestLoading: false,
          },
        },
      };

    case ADD_CONTRACTOR_STEP3_REQUEST:
      return {
        ...state,
        addContractor: {
          ...state?.addContractor,
          step3: {
            ...state?.addContractor?.step3,
            submitFormRequestLoading: true,
          },
        },
      };

    case ADD_CONTRACTOR_STEP3_SUCCESS:
      return {
        ...state,
        addContractor: {
          ...state?.addContractor,
          step3: {
            ...state?.addContractor?.step3,
            data: action?.payload?.data,
            submitFormRequestLoading: false,
            form: action?.payload?.formData,
            previouslySubmittedForm: action.payload?.formData,
          },
        },
      };

    case ADD_CONTRACTOR_STEP3_FAILURE:
      return {
        ...state,
        addContractor: {
          ...state?.addContractor,
          step3: {
            ...state?.addContractor?.step3,
            submitFormRequestLoading: false,
          },
        },
      };

    case ADD_CONTRACTOR_STEP4_REQUEST:
      return {
        ...state,
        addContractor: {
          ...state?.addContractor,
          step4: {
            ...state?.addContractor?.step4,
            submitFormRequestLoading: true,
          },
        },
      };

    case ADD_CONTRACTOR_STEP4_SUCCESS:
      return {
        ...state,
        addContractor: {
          ...state?.addContractor,
          step4: {
            ...state?.addContractor?.step4,
            data: action?.payload?.data,
            submitFormRequestLoading: false,
            form: action?.payload?.formData,
            previouslySubmittedForm: action.payload?.formData,
          },
        },
      };

    case ADD_CONTRACTOR_STEP4_FAILURE:
      return {
        ...state,
        addContractor: {
          ...state?.addContractor,
          step4: {
            ...state?.addContractor?.step4,
            submitFormRequestLoading: false,
          },
        },
      };

    case ADD_CONTRACTOR_STEP5_REQUEST:
      return {
        ...state,
        addContractor: {
          ...state?.addContractor,
          step5: {
            ...state?.addContractor?.step5,
            submitFormRequestLoading: true,
          },
        },
      };

    case ADD_CONTRACTOR_STEP5_SUCCESS:
      return {
        ...state,
        addContractor: {
          ...state?.addContractor,
          step5: {
            ...state?.addContractor?.step5,
            data: action?.payload?.data,
            submitFormRequestLoading: false,
            form: action?.payload?.formData,
            previouslySubmittedForm: action.payload?.formData,
          },
        },
      };

    case ADD_CONTRACTOR_STEP5_FAILURE:
      return {
        ...state,
        addContractor: {
          ...state?.addContractor,
          step5: {
            ...state?.addContractor?.step5,
            submitFormRequestLoading: false,
          },
        },
      };

    case UPDATE_CONTRACTOR_CERTIFICATES_STEP5:
      return {
        ...state,
        addContractor: {
          ...state?.addContractor,
          step5: {
            ...state?.addContractor?.step5,
            data: {
              ...state?.addContractor?.step5?.data,
              certifications: action?.payload?.certifications,
            },
          },
        },
      };

    case SETUP_EDIT_CONTRACTOR_REQUEST:
      return {
        ...state,
        addContractor: {
          ...state?.addContractor,
          contractorData: {
            ...state?.addContractor?.contractorData,
            // isEditing: true,
            loading: true,
          },
        },
      };

    case SETUP_EDIT_CONTRACTOR_SUCCESS:
      return {
        ...state,
        addContractor: {
          ...action?.payload,
          contractorData: {
            ...state?.addContractor?.contractorData,
            loading: false,
            loaded: true,
          },
        },
      };

    case SETUP_EDIT_CONTRACTOR_FAILURE:
      return {
        ...state,
        addContractor: addContractorInit,
      };

    case CLEAR_ADD_CONTRACTOR: {
      return {
        ...state,
        addContractor: {
          ...addContractorInit,
          // reset: {
          //   ...state?.addContractor?.reset,
          //   count:
          //     typeof state?.addContractor?.reset?.count === "number"
          //       ? (state?.addContractor?.reset?.count + 1) % 10
          //       : 0,
          // },
        },
      };
    }

    // toggle onboarding status
    case TOGGLE_ONBOARDING_STATUS_REQUEST:
      return {
        ...state,
        isLoading: true,
      };

    case TOGGLE_ONBOARDING_STATUS_FAILURE:
      return {
        ...state,
        isLoading: false,
      };

    case TOGGLE_ONBOARDING_STATUS_SUCCESS:
      return {
        ...state,
        isLoading: false,
      };

    // po history keys
    case GET_PO_HISTORY_REQUEST:
      return {
        ...state,
        poHistory: {
          ...state,
          isPOHistoryLoading: true,
        },
      };

    case GET_PO_HISTORY_FAILURE:
      return {
        ...state,
        poHistory: {
          ...state,
          isPOHistoryLoading: false,
        },
      };

    case GET_PO_HISTORY_SUCCESS:
      return {
        ...state,
        poHistory: {
          ...state,
          isPOHistoryLoading: false,
          data: action?.payload?.data,
        },
      };

    // toggle adp status
    case TOGGLE_ADP_STATUS_REQUEST:
      return {
        ...state,
        adpLoading: true,
      };

    case TOGGLE_ADP_STATUS_FAILURE:
      return {
        ...state,
        adpLoading: false,
      };

    case TOGGLE_ADP_STATUS_SUCCESS:
      return {
        ...state,
        adpLoading: false,
      };

    // bulk update contractor data
    case BULK_EDIT_CONTRACTOR_REQUEST:
      return {
        ...state,
        bulkEditLoader: true,
      };

    case BULK_EDIT_CONTRACTOR_FAILURE:
      return {
        ...state,
        bulkEditLoader: false,
      };
    case BULK_EDIT_CONTRACTOR_SUCCESS:
      return {
        ...state,
        bulkEditLoader: false,
      };

    case BULK_UPDATE_CONTRACTOR_AND_PO_STATUS_REQUEST: {
      return {
        ...state,
        bulkEditWithPOLoader: true,
      };
    }

    case BULK_UPDATE_CONTRACTOR_AND_PO_STATUS_SUCCESS: {
      return {
        ...state,
        bulkEditWithPOLoader: false,
      };
    }

    // reset contractor password
    case RESET_CONTRACTOR_PASSWORD_REQUEST: {
      return {
        ...state,
        isLoading: true,
      };
    }

    case RESET_CONTRACTOR_PASSWORD_SUCCESS: {
      return {
        ...state,
        isLoading: false,
      };
    }

    case RESET_CONTRACTOR_PASSWORD_FAILURE: {
      return {
        ...state,
        isLoading: false,
      };
    }

    default:
      return state;
  }
};

export { contractorReducer, initialState };